import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { superuserGroupsBackend } from './superuser-groups.backend';
import { superuserGroupsReducer } from './superuser-groups.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('superuserGroups', superuserGroupsReducer),
    BackendModule.forFeature('superuserGroups', superuserGroupsBackend),
  ],
})
export class DatastoreSuperuserGroupsModule {}
